import { render, staticRenderFns } from "./EntryDonut.vue?vue&type=template&id=2ec67a3c"
import script from "./EntryDonut.vue?vue&type=script&lang=js"
export * from "./EntryDonut.vue?vue&type=script&lang=js"
import style0 from "./EntryDonut.vue?vue&type=style&index=0&id=2ec67a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports